/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Creating_SegmentsInputs */

const en_audio_description_export_status_creating_segments = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating audio segments...`)
};

const fr_audio_description_export_status_creating_segments = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création des segments audio...`)
};

const de_audio_description_export_status_creating_segments = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiosegmente erstellen...`)
};

const it_audio_description_export_status_creating_segments = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazione di segmenti audio...`)
};

const ru_audio_description_export_status_creating_segments = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание аудиофрагментов...`)
};

const es_audio_description_export_status_creating_segments = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando segmentos de audio...`)
};

const zh_cn2_audio_description_export_status_creating_segments = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在创建音频片段……`)
};

const ja_audio_description_export_status_creating_segments = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ セグメントを作成しています...`)
};

const hi_audio_description_export_status_creating_segments = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो सेगमेंट तैयार किए जा रहे हैं...`)
};

const pt_pt2_audio_description_export_status_creating_segments = /** @type {(inputs: Audio_Description_Export_Status_Creating_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criando segmentos de áudio...`)
};

/**
* | output |
* | --- |
* | "Creating audio segments..." |
*
* @param {Audio_Description_Export_Status_Creating_SegmentsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_creating_segments = /** @type {((inputs?: Audio_Description_Export_Status_Creating_SegmentsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Creating_SegmentsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_creating_segments(inputs)
	if (locale === "de") return de_audio_description_export_status_creating_segments(inputs)
	if (locale === "it") return it_audio_description_export_status_creating_segments(inputs)
	if (locale === "ru") return ru_audio_description_export_status_creating_segments(inputs)
	if (locale === "es") return es_audio_description_export_status_creating_segments(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_creating_segments(inputs)
	if (locale === "ja") return ja_audio_description_export_status_creating_segments(inputs)
	if (locale === "hi") return hi_audio_description_export_status_creating_segments(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_creating_segments(inputs)
	return en_audio_description_export_status_creating_segments(inputs)
});